import { useEffect } from 'react';
import { getAddress } from 'viem';
import { useConfig } from 'wagmi';
import { useReadDelegatedAccountOwner } from 'sc-interfaces';
import useAppStore from '../store/rootStore.ts';

export function useDelegatedOwnerCheck() {
  const config = useConfig();
  const isDelegated = useAppStore((state) => state.isDelegated);
  const activeDelegatedAddress = useAppStore((state) => state.activeDelegatedAddress);
  const connectedWalletAddress = useAppStore((state) => state.connectedWalletAddress);
  const setDelegatedOwner = useAppStore((state) => state.setDelegatedOwner);
  const chainId = useAppStore((state) => state.config?.chain.id);

  const delegatedAddress = isDelegated && activeDelegatedAddress ? getAddress(activeDelegatedAddress) : undefined;

  const { data: daOwner } = useReadDelegatedAccountOwner({
    address: delegatedAddress,
    config,
    chainId,
    query: { enabled: !!delegatedAddress },
  });

  useEffect(() => {
    if (!isDelegated) {
      return;
    }
    if (daOwner && connectedWalletAddress) {
      setDelegatedOwner(getAddress(daOwner) === getAddress(connectedWalletAddress));
    }
  }, [isDelegated, daOwner, connectedWalletAddress, setDelegatedOwner]);
}
